import { VALIDATION_MESSAGES } from '@/constants'

function getValidityState(event) {
  const validity = event.currentTarget.validity

  for (const key in validity) {
    if (validity[key]) return VALIDATION_MESSAGES[key]
  }

  return null
}

export default getValidityState
